module.exports = __webpack_public_path__ + "static/media/macmini.550b6d14.svg";